// @flow

import * as React from 'react';
import classNames from '@ta/common.classnames';
import { Icon } from '@ta/styleguide.icon';
import { localize } from '@ta/common.i18n';

import styles from './ImprovedScrollFeedToolTip.less';

/**
 *
 * This is an improved scroll feed tool tip UI. TRVX-11324
 * Similar to the ScrollFeedToolTip, with updated designs.
 * Only contains UI logic here.
 *
 * */

type Props = {|
  /* Callback for when the user clicks the button, defaults to nothing */
  onClick?: () => void,

  /* Is this a ghost impression? if so, hide everything but behave the same */
  isGhost?: boolean,
|};

const ImprovedScrollFeedToolTip = ({ onClick, isGhost }: Props) => (
  <div
    className={classNames(
      styles.container,
      onClick ? styles.clickable : '',
      isGhost ? styles.ghost : '',
    )}
    onClick={onClick}
  >
    <Icon name="arrow-down" className={styles.downArrow} />
    {/* Scroll for travel ideas */}
    {localize('scroll_tooltip_variant_1')}
  </div>
);

ImprovedScrollFeedToolTip.defaultProps = {
  onClick: /* istanbul ignore next */ () => {},
  isGhost: false,
};

export default ImprovedScrollFeedToolTip;
